import BaseStorageInterface from "./BaseStorage";
import CookieStorage from "./CookieStorage";

export type StorageManagerType = {
    storage: BaseStorageInterface,
    getFromStorage(): string | null,
    storeToStorage(value: string): void,
    removeFromStorage(): void,
}

const defaultStorage = CookieStorage;

const JSONStorageManager: StorageManagerType = {
    storage: defaultStorage,
    getFromStorage() {
        return this.storage.getItem();
    },
    storeToStorage(value) {
        return this.storage.setItem(value)
    },
    removeFromStorage() {
        return this.storage.removeItem();
    }
}



export default JSONStorageManager;
